import { View } from "react-native";
import LogoIcon from '../../assets/svg/ic_round_logo.svg';
import MisoLogo from "../../assets/svg/ic_round_logo_miso.svg";
import { white } from "../../assets/style/colors";
import { isMiso } from "../../../imsdk/api";


export const SplashScreen = () => {
    return (
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: white }}>
            {isMiso ? <MisoLogo width={120} height={120} /> : <LogoIcon width={120} height={120} />}
        </View>
    );
}
